import AsyncStorage from "@react-native-async-storage/async-storage";
import { getDateTimePlusHour, logout } from "../Utils";
import { AsyncStorageKeys } from "../../Types";
import axios, { AxiosError } from "axios";
export const CODE_SESSION_ERROR = 20008;
export const CODE_SESSION_EXPIRED = 40011;

export const fetchWrapper = async (url: any, requestOptions: any = {}) => {
	localStorage.setItem(AsyncStorageKeys.networkError, "false");
	const fetchData = await axios({
		url,
		method: requestOptions.method,
		headers: requestOptions.headers,
		data: requestOptions.body,
	})
		.then(async (response: any) => {
			const resJson = response.data;
			await AsyncStorage.setItem(AsyncStorageKeys.idleExpiry, getDateTimePlusHour().toString());
			return resJson;
		})
		.catch((e) => {
			if (e.code === AxiosError.ERR_NETWORK) {
				localStorage.setItem(AsyncStorageKeys.networkError, "true");
			}
			return e;
		});

	if (url.indexOf("logout") === -1 && (fetchData?.responseCode === CODE_SESSION_ERROR || fetchData?.responseCode === CODE_SESSION_EXPIRED)) {
		localStorage.setItem(AsyncStorageKeys.sessionExpired, "true");
		await logout();
	}

	return fetchData;
};
